module.exports = __webpack_public_path__ + "img/dc-all-devices.06da0924.svg";